import { Cube, Query, TCubeDimension, TCubeMeasure } from "@cubejs-client/core"

export type View = "planning" | "buying" | "billing"

export const getQueryByView = (cubeName: View, meta: Cube[]) => {
  const filteredCube =
    meta?.find((x: { name: string }) => x.name === cubeName) || ({} as Cube)

  const { dimensions: _dimensions, measures: _measures } = filteredCube

  const dimensions = _dimensions?.map((x: TCubeDimension) => x.name)

  const measures = _measures?.map((x: TCubeMeasure) => x.name)

  const query = { dimensions, measures } as Query

  return query
}
